import SeoHead from '@presentation/seo/SeoHead'

type LegalSection = {
  title: string
  paragraphs: string[]
}

const COOKIE_POLICY_SECTIONS: LegalSection[] = [
  {
    title: 'Introduction',
    paragraphs: [
      'This Cookie Policy explains how Parkinson\'s Insights, in collaboration with PD Buddy (Good Vibes Technologies Ltd) and No Silver Bullet 4PD, uses cookies and similar technologies to recognise you when you visit our website. It explains what these technologies are, why we use them, and your rights to control our use of them.',
    ],
  },
  {
    title: 'What are Cookies?',
    paragraphs: [
      'Cookies are small data files that are placed on your computer or mobile device when you visit a website. They are widely used by website owners to make their websites work, or to work more efficiently, as well as to provide reporting information.',
    ],
  },
  {
    title: 'Why We Use Cookies',
    paragraphs: [
      'We use first-party and third-party cookies for several reasons. Some cookies are required for technical reasons in order for our platform to operate, which we refer to as "essential" or "strictly necessary" cookies. Other cookies enable us to track and target the interests of our community to enhance the experience on our website and app.',
    ],
  },
  {
    title: 'Types of Cookies We Use',
    paragraphs: [
      'Strictly Necessary Cookies: These are essential for you to browse the website and use its features, such as accessing secure areas like the PD Buddy user dashboard.',
      'Performance and Analytics Cookies: These cookies collect information about how you use our website - for instance, which articles are read most frequently. We use this data to improve how the platform works and to tailor our content to the needs of people with the condition.',
      'Functionality Cookies: These allow our website to remember choices you make (such as your language preference or region) and provide enhanced, more personal features.',
      'Sovereign AI Interaction Cookies: To provide a seamless experience with our AI agents, we may use cookies to remember the context of your current session so the AI can provide more accurate and helpful responses.',
    ],
  },
  {
    title: 'Control and Consent',
    paragraphs: [
      'When you first visit Parkinson\'s Insights, we present a CookieYes consent banner. You can accept or reject non-essential cookies, including analytics cookies.',
      'You can update your preferences at any time using the CookieYes preference controls made available on the site.',
      'Browser Controls: You can set or amend your web browser controls to accept or refuse cookies. If you choose to reject cookies, you may still use our website, though your access to some functionality and areas may be restricted.',
      'Opting Out: Most advertising networks offer you a way to opt out of targeted advertising. If you would like to find out more information, please visit AboutAds.info or Your Online Choices.',
    ],
  },
  {
    title: 'Changes to This Policy',
    paragraphs: [
      'We may update this Cookie Policy from time to time to reflect, for example, changes to the cookies we use or for other operational, legal, or regulatory reasons. Please re-visit this Cookie Policy regularly to stay informed about our use of cookies and related technologies.',
    ],
  },
  {
    title: 'Contact Us',
    paragraphs: [
      'If you have any questions about our use of cookies or other technologies, please email us at: support@goodvibestechnologies.com.',
    ],
  },
]

export default function CookiePolicyPage() {
  return (
    <main className="bg-background py-8 sm:py-12">
      <SeoHead
        title="Cookie Policy | Parkinson's Insights"
        description="Learn how Parkinson's Insights uses cookies and similar technologies for essential functionality and analytics."
        canonicalPath="/legal/cookie-policy"
      />
      <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8">
        <div className="rounded-2xl border border-border-light bg-surface p-6 shadow-sm sm:p-8">
          <header className="border-b border-border-light pb-5 sm:pb-6">
            <h1 className="text-2xl font-bold tracking-tight text-primary sm:text-3xl">
              Cookie Policy
            </h1>
            <p className="mt-2 text-sm font-medium text-text-secondary">
              Last Updated: March 2026
            </p>
          </header>

          {COOKIE_POLICY_SECTIONS.map((section) => (
            <section
              key={section.title}
              className="border-b border-border-light py-5 last:border-b-0 last:pb-0 sm:py-6"
            >
              <h2 className="text-xl font-bold tracking-tight text-primary sm:text-2xl">
                {section.title}
              </h2>
              <div className="mt-4 space-y-4">
                {section.paragraphs.map((paragraph) => (
                  <p
                    key={paragraph}
                    className="text-base leading-relaxed text-text-primary"
                  >
                    {paragraph}
                  </p>
                ))}
              </div>
            </section>
          ))}
        </div>
      </div>
    </main>
  )
}
